import styled from 'styled-components';

const Link = styled.a`
  color: ${({ theme }) => theme.palette.common.blue4};
`;

export default Link;
